export default "__VITE_ASSET__bfb2bc8e__"